import { render, staticRenderFns } from "./AfterCallWork.vue?vue&type=template&id=21f8adf8&scoped=true&"
import script from "./AfterCallWork.vue?vue&type=script&lang=js&"
export * from "./AfterCallWork.vue?vue&type=script&lang=js&"
import style0 from "./AfterCallWork.vue?vue&type=style&index=0&id=21f8adf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f8adf8",
  null
  
)

export default component.exports